module.exports = __webpack_public_path__ + "img/expar_logo_white.b98c33bb.png";